import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend
);

export const options = {
  responsive: true,
  plugins: {
  },
};

const labels = ['15/11', '17/11', '19/11', '21/11', '23/11', '25/11', '27/11'];

export const data = {
  labels,
  datasets: [
    {
      fill: true,
      label: 'Premium',
      data: [0.3, 0.2, 0.3, 0.5, 0.3, 0.4, 0.4],
      borderColor: 'rgb(53, 162, 235)',
      backgroundColor: 'rgba(53, 162, 235, 0.5)',
    },
  ],
};

export default function Graph() {
  return <Line className='rounded-lg bg-white bg-opacity-70 hover:bg-gray-100' options={options} data={data} />;
}
